import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLayoutVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.5 21.75C7.98122 21.75 6.75 20.5188 6.75 19C6.75 17.4812 7.98122 16.25 9.5 16.25H14.5C16.0188 16.25 17.25 17.4812 17.25 19C17.25 20.5188 16.0188 21.75 14.5 21.75H9.5ZM15.75 19C15.75 18.3096 15.1904 17.75 14.5 17.75H9.5C8.80964 17.75 8.25 18.3096 8.25 19C8.25 19.6904 8.80964 20.25 9.5 20.25H14.5C15.1904 20.25 15.75 19.6904 15.75 19Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.5 14.75C7.98122 14.75 6.75 13.5188 6.75 12C6.75 10.4812 7.98122 9.25 9.5 9.25H14.5C16.0188 9.25 17.25 10.4812 17.25 12C17.25 13.5188 16.0188 14.75 14.5 14.75H9.5ZM15.75 12C15.75 11.3096 15.1904 10.75 14.5 10.75H9.5C8.80964 10.75 8.25 11.3096 8.25 12C8.25 12.6904 8.80964 13.25 9.5 13.25H14.5C15.1904 13.25 15.75 12.6904 15.75 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.75 5C6.75 3.48122 7.98122 2.25 9.5 2.25H14.5C16.0188 2.25 17.25 3.48122 17.25 5C17.25 6.51878 16.0188 7.75 14.5 7.75H9.5C7.98122 7.75 6.75 6.51878 6.75 5ZM14.5 6.25C15.1904 6.25 15.75 5.69036 15.75 5C15.75 4.30964 15.1904 3.75 14.5 3.75H9.5C8.80964 3.75 8.25 4.30964 8.25 5C8.25 5.69036 8.80964 6.25 9.5 6.25H14.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLayoutVertical as ReactComponent };
